import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import Button from "./Button";

export default function InfoModal({ open, setOpen }) {
  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50 blur-modal" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-[337px] transform overflow-hidden text-center rounded-[12px] bg-white p-9 text-left align-middle shadow-xl transition-all">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 text-grey mb-3 mx-auto"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                    />
                  </svg>
                  <Dialog.Title
                    as="h3"
                    className="text-[24px] font-bold text-secondary"
                  >
                    Receipt requirements
                  </Dialog.Title>
                  <div className="mt-4">
                    <p className="text-xs text-secondary">
                      Please ensure all of the below information can be seen in
                      the photo you upload.
                    </p>
                  </div>
                  <BoxContent />
                  <Button
                    type="button"
                    title={"Got it"}
                    onClick={() => setOpen(false)}
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

const BoxContent = () => {
  return (
    <div className="bg-primary bg-opacity-[0.08] rounded-[3px] p-[18px] mt-4 mb-10 flex flex-col space-y-3">
      <div className="flex items-center space-x-2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#08792A" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.90909 7.54545C7.55764 7.54545 7.27273 7.83036 7.27273 8.18182V17.0909C7.27273 17.4424 7.55764 17.7273 7.90909 17.7273H16.8182C17.1696 17.7273 17.4545 17.4424 17.4545 17.0909V8.18182C17.4545 7.83036 17.1696 7.54545 16.8182 7.54545H7.90909ZM6 8.18182C6 7.12746 6.85473 6.27273 7.90909 6.27273H16.8182C17.8725 6.27273 18.7273 7.12746 18.7273 8.18182V17.0909C18.7273 18.1453 17.8725 19 16.8182 19H7.90909C6.85473 19 6 18.1453 6 17.0909V8.18182Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9091 5C15.2605 5 15.5455 5.28491 15.5455 5.63636V8.18182C15.5455 8.53327 15.2605 8.81818 14.9091 8.81818C14.5576 8.81818 14.2727 8.53327 14.2727 8.18182V5.63636C14.2727 5.28491 14.5576 5 14.9091 5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.81818 5C10.1696 5 10.4545 5.28491 10.4545 5.63636V8.18182C10.4545 8.53327 10.1696 8.81818 9.81818 8.81818C9.46673 8.81818 9.18182 8.53327 9.18182 8.18182V5.63636C9.18182 5.28491 9.46673 5 9.81818 5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 10.7273C6 10.3758 6.28491 10.0909 6.63636 10.0909H18.0909C18.4424 10.0909 18.7273 10.3758 18.7273 10.7273C18.7273 11.0787 18.4424 11.3636 18.0909 11.3636H6.63636C6.28491 11.3636 6 11.0787 6 10.7273Z"
            fill="white"
          />
        </svg>
        <p className="text-xs text-secondary font-bold">Date and Time</p>
      </div>
      <div className="flex items-center space-x-2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#08792A" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4823 5.00049C11.6229 5.0005 12.4823 5.00048 11.6229 5.00049H7.39995C7.39995 5.00049 7.39995 4.97997 7.07688 5.20376L5 8.23114L5 16.9441C5 17.4894 5.22124 18.0123 5.61506 18.3978C6.00887 18.7834 6.54299 19 7.09993 19H9.89983H14.0997H16.8996C17.4565 19 17.9906 18.7834 18.3845 18.3978C18.7783 18.0123 18.9995 17.4894 18.9995 16.9441L18.9995 8.23114L16.9226 5.20376C16.7052 5.00049 16.7052 5.00049 16.7052 5.00049H12.4823ZM9.19986 17.6294V18.3147C9.19986 18.6932 9.51325 19 9.89983 19C10.2864 19 10.5998 18.6932 10.5998 18.3147V17.6294H13.3997V15.2309H10.5998V17.6294H9.19986ZM9.19986 17.6294H7.09993C6.91428 17.6294 6.73624 17.5572 6.60497 17.4287C6.4737 17.3002 6.39995 17.1259 6.39995 16.9441L6.39995 8.67803L8.12599 6.07738H11.9998H15.8766L17.5996 8.67803L17.5996 16.9441C17.5996 17.1259 17.5258 17.3002 17.3945 17.4287C17.2633 17.5572 17.0852 17.6294 16.8996 17.6294H14.7997V14.5456C14.7997 14.1671 14.4863 13.8603 14.0997 13.8603H9.89983C9.51325 13.8603 9.19986 14.1671 9.19986 14.5456V17.6294Z"
            fill="white"
          />
          <path
            d="M9.89983 19C10.2864 19 10.5998 18.6932 10.5998 18.3147V17.6294H9.19986V18.3147C9.19986 18.6932 9.51325 19 9.89983 19Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.53844 8.2312C5.83582 8.2312 6.07689 8.47227 6.07689 8.76964C6.07689 9.19806 6.24707 9.60892 6.55 9.91185C6.85294 10.2148 7.2638 10.385 7.69221 10.385C8.12063 10.385 8.53149 10.2148 8.83442 9.91185C9.13736 9.60892 9.30754 9.19806 9.30754 8.76964C9.30754 8.47227 9.54861 8.2312 9.84599 8.2312C10.1434 8.2312 10.3844 8.47227 10.3844 8.76964C10.3844 9.48366 10.1008 10.1684 9.5959 10.6733C9.09101 11.1782 8.40623 11.4619 7.69221 11.4619C6.97819 11.4619 6.29342 11.1782 5.78853 10.6733C5.28364 10.1684 5 9.48366 5 8.76964C5 8.47227 5.24107 8.2312 5.53844 8.2312Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.84598 8.2312C10.1434 8.2312 10.3844 8.47227 10.3844 8.76964C10.3844 9.19806 10.5546 9.60892 10.8575 9.91185C11.1605 10.2148 11.5713 10.385 11.9998 10.385C12.4282 10.385 12.839 10.2148 13.142 9.91185C13.4449 9.60892 13.6151 9.19806 13.6151 8.76964C13.6151 8.47227 13.8562 8.2312 14.1535 8.2312C14.4509 8.2312 14.692 8.47227 14.692 8.76964C14.692 9.48366 14.4083 10.1684 13.9034 10.6733C13.3986 11.1782 12.7138 11.4619 11.9998 11.4619C11.2857 11.4619 10.601 11.1782 10.0961 10.6733C9.59118 10.1684 9.30754 9.48366 9.30754 8.76964C9.30754 8.47227 9.54861 8.2312 9.84598 8.2312Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1535 8.2312C14.4509 8.2312 14.692 8.47227 14.692 8.76964C14.692 9.19806 14.8622 9.60892 15.1651 9.91185C15.468 10.2148 15.8789 10.385 16.3073 10.385C16.7357 10.385 17.1466 10.2148 17.4495 9.91185C17.7524 9.60892 17.9226 9.19806 17.9226 8.76964C17.9226 8.47227 18.1637 8.2312 18.4611 8.2312C18.7584 8.2312 18.9995 8.47227 18.9995 8.76964C18.9995 9.48366 18.7159 10.1684 18.211 10.6733C17.7061 11.1782 17.0213 11.4619 16.3073 11.4619C15.5933 11.4619 14.9085 11.1782 14.4036 10.6733C13.8987 10.1684 13.6151 9.48366 13.6151 8.76964C13.6151 8.47227 13.8562 8.2312 14.1535 8.2312Z"
            fill="white"
          />
        </svg>

        <p className="text-xs text-secondary font-bold">Store name</p>
      </div>

      <p className="text-secondary text-xs text-left pt-2">
        If these details are not visible, your receipt may not be able to be
        processed.
      </p>
    </div>
  );
};
